<template id="pagination">
  <div class="pagination" aria-live="polite" role="alert" aria-label="Pagination des formateurs">

    <div v-if="nbrPages>1" class="base-pagination">
        <PaginationBoutonFleche v-if="pageCourante > 1" :disabled="isPreviousButtonDisabled" @click="previousPage" text="gauche" />
      <ul :class="[{'ajouterPointsDebut' : ajouterPointsDebut,'ajouterPointsFin' : ajouterPointsFin}, 'pagination-list']" >
        <PaginationPage v-for="paginationTrigger in paginationTriggers" :class="{'base-pagination__description--current':paginationTrigger === pageCourante}" :key="paginationTrigger" :pageNumber="paginationTrigger" @loadPage="onLoadPage" />
      </ul>
      <PaginationBoutonFleche v-if="pageCourante < nbrPages" :disabled="isNextButtonDisabled" @click="nextPage" text="droite" />
     
    </div>

  </div>
</template>

<script>
import PaginationBoutonFleche from './Pagination_bouton_fleche'
import PaginationPage from './Pagination_page'

export default{
    name:"PaginationPrincipal",
    components: {
      PaginationBoutonFleche,
      PaginationPage
    },
    emits: ['previous-page', 'next-page', 'load-page'],
    props: {
      pageCourante: Number,
      nbrPages: Number,
      nbrResultats: Number,
      formateurs: Array,
      visiblePagesCount: {
        type: Number,
        default: 5
      }
    },
    data(){
      return{
        ajouterPointsDebut:false,
        ajouterPointsFin:true
      }
    }, 
    methods:{
      nextPage() {
        this.$emit('next-page', 'next')
        this.AjouterRetirerPointsPagination()
      },
      previousPage() {
        this.$emit('previous-page', 'previous')
        this.AjouterRetirerPointsPagination()
      },
      onLoadPage(value) {
        this.$emit("load-page", value)
        this.AjouterRetirerPointsPagination()
      },
      async AjouterRetirerPointsPagination(){
        if(this.pageCourante > 3){
          this.ajouterPointsDebut=true;
        }else{
          this.ajouterPointsDebut=false;
        }
        if(this.pageCourante >= this.nbrPages - 2 || this.pageCourante == this.nbrPages){
          this.ajouterPointsFin=false;
        }else{
           this.ajouterPointsFin=true;
        }
      }
    },
    computed: {
      isPreviousButtonDisabled() {
        return this.pageCourante === 1
      },
      isNextButtonDisabled() {
        return this.pageCourante === this.nbrPages
      },
      paginationTriggers() {

        const currentPage = this.pageCourante
        const pageCount = this.nbrPages
        let visiblePagesCount = this.visiblePagesCount
        const visiblePagesThreshold = (visiblePagesCount - 1) / 2
        let pagintationTriggersArray = Array(this.visiblePagesCount - 1).fill(0)
        
        if(this.formateurs.length<= this.nbrResultats){
          visiblePagesCount=1;
          pagintationTriggersArray = Array(1 - 1).fill(0)
        }
        if(this.formateurs.length<=(this.nbrResultats * 2) && this.formateurs.length >=(this.nbrResultats + 1)){
          visiblePagesCount=2;
          pagintationTriggersArray = Array(2 - 1).fill(0)
        }
        if(this.formateurs.length<=(this.nbrResultats * 3) && this.formateurs.length >=((this.nbrResultats * 2)+1)){
          visiblePagesCount=3;
          pagintationTriggersArray = Array(3 - 1).fill(0)
          console.log('ici1');
        }
        if(this.formateurs.length<=(this.nbrResultats * 4) && this.formateurs.length >=((this.nbrResultats * 3)+1)){
          visiblePagesCount=4;
          pagintationTriggersArray = Array(4 - 1).fill(0)
        }


        if (currentPage <= visiblePagesThreshold + 1) {
          pagintationTriggersArray[0] = 1
          
          const pagintationTriggers = pagintationTriggersArray.map(
            (paginationTrigger, index) => {
              return pagintationTriggersArray[0] + index 
            }
          )
          pagintationTriggers.push(pageCount)
          return pagintationTriggers
        }

        if (currentPage >= pageCount - visiblePagesThreshold + 1) {

          const pagintationTriggers = pagintationTriggersArray.map(
            (paginationTrigger, index) => {
              return pageCount - index
            }
          )
          pagintationTriggers.reverse().unshift(1)
          return pagintationTriggers
        }
        

        pagintationTriggersArray[0] = currentPage - visiblePagesThreshold + 1
        const pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => {

            return pagintationTriggersArray[0] + index
          }
        )

        pagintationTriggers.unshift(1);

        pagintationTriggers[pagintationTriggers.length - 1] = pageCount

        return pagintationTriggers
      }
    }
}
</script>